import { RefObject } from "react";
import { TextBox, TextBoxStates } from "store/features/memeGenerator/types";
import { ResizeHandler } from "./ResizeHandler/ResizeHandler";

export interface ResizeHandlersProps {
    textBox: TextBox;
    contentEditableRef: RefObject<HTMLElement>;
    textBoxContainerRef: RefObject<HTMLElement>;
}

const width = 18;
const height = 18;

export const ResizeHandlers = ({ textBox, contentEditableRef, textBoxContainerRef }: ResizeHandlersProps) => {
    const props = {
        textBoxId: textBox.id,
        contentEditableRef,
        textBoxContainerRef,
    };
    if (textBox.state === TextBoxStates.BLUR) return null;
    return (
        <>
            {/* n */}
            <ResizeHandler
                direction="n"
                {...props}
                className="absolute bg-irGray-100 rounded cursor-ns-resize touch-none opacity-90 border border-gray-600 z-50"
                style={{
                    top: `-${height / 2}px`,
                    right: `calc(50% - ${width / 2}px)`,
                    width: `${width}px`,
                    height: `${height}px`,
                }}
            />

            {/* ne */}
            <ResizeHandler
                direction="ne"
                {...props}
                className="cursor-nesw-resize absolute bg-irGray-100 rounded touch-none opacity-90 border border-gray-600 z-50"
                style={{
                    top: `-${height / 2}px`,
                    right: `-${width / 2}px`,
                    width: `${width}px`,
                    height: `${height}px`,
                }}
            />

            {/* e */}
            <ResizeHandler
                direction="e"
                {...props}
                className="cursor-ew-resize absolute bg-irGray-100 rounded touch-none opacity-90 border border-gray-600 z-50"
                style={{
                    top: `calc(50% - ${width / 2}px)`,
                    right: `-${width / 2}px`,
                    width: `${width}px`,
                    height: `${height}px`,
                }}
            />

            {/* se */}
            <ResizeHandler
                direction="se"
                {...props}
                className="cursor-nwse-resize absolute bg-irGray-100 rounded touch-none opacity-90 border border-gray-600 z-50"
                style={{
                    bottom: `-${height / 2}px`,
                    right: `-${width / 2}px`,
                    width: `${width}px`,
                    height: `${height}px`,
                }}
            />

            {/* s */}
            <ResizeHandler
                direction="s"
                {...props}
                className="absolute bg-irGray-100 rounded cursor-ns-resize touch-none opacity-90 border border-gray-600 z-50"
                style={{
                    bottom: `-${height / 2}px`,
                    right: `calc(50% - ${width / 2}px)`,
                    width: `${width}px`,
                    height: `${height}px`,
                }}
            />

            {/* sw */}
            <ResizeHandler
                direction="sw"
                {...props}
                className="absolute bg-irGray-100 rounded cursor-nesw-resize touch-none opacity-90 border border-gray-600 z-50"
                style={{
                    bottom: `-${height / 2}px`,
                    left: `-${width / 2}px`,
                    width: `${width}px`,
                    height: `${height}px`,
                }}
            />

            {/* w */}
            <ResizeHandler
                direction="w"
                {...props}
                className="absolute bg-irGray-100 rounded cursor-ew-resize touch-none opacity-90 border border-gray-600 z-50"
                style={{
                    top: `calc(50% - ${height / 2}px)`,
                    left: `-${width / 2}px`,
                    width: `${width}px`,
                    height: `${height}px`,
                }}
            />

            {/* nw */}
            <ResizeHandler
                direction="nw"
                {...props}
                className="absolute bg-irGray-100 rounded cursor-nwse-resize touch-none opacity-90 border border-gray-600 z-50"
                style={{
                    top: `-${height / 2}px`,
                    left: `-${width / 2}px`,
                    width: `${width}px`,
                    height: `${height}px`,
                }}
            />
        </>
    );
};
